import initiativeRegistry from './initiativeRegistry';
import singleTtrRegistry from './singleTtrRegistry';
import unilateralNonTrRegistry from './unilateralNonTrRegistry';

export default {
  singleTtrRegistry,
  unilateralNonTrRegistry,
  initiativeRegistry,
};
